export class QueryResultsModel {
	// fields
	results: any[];
	total_count: number;
	errorMessage: string;

	constructor(_items: any[] = [], _totalCount: number = 0, _errorMessage: string = '') {
		this.results = _items;
		this.total_count = _totalCount;
	}
}
